// extracted by mini-css-extract-plugin
export default {"text":"HeadingComponent_text__Nw3aT"};